var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74385 8.1625C11.5146 8.1625 12.9501 6.72702 12.9501 4.95625C12.9501 3.18549 11.5146 1.75 9.74385 1.75C7.97309 1.75 6.5376 3.18549 6.5376 4.95625C6.5376 6.72702 7.97309 8.1625 9.74385 8.1625Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97504 12.6508C5.03819 12.6508 5.90005 11.7889 5.90005 10.7258C5.90005 9.66263 5.03819 8.80078 3.97504 8.80078C2.91189 8.80078 2.05005 9.66263 2.05005 10.7258C2.05005 11.7889 2.91189 12.6508 3.97504 12.6508Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3876 14.2508C11.2713 14.2508 11.9876 13.5344 11.9876 12.6508C11.9876 11.7671 11.2713 11.0508 10.3876 11.0508C9.50394 11.0508 8.7876 11.7671 8.7876 12.6508C8.7876 13.5344 9.50394 14.2508 10.3876 14.2508Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.c80549ceda73ee1096cfb25d9c15236b.svg";
export { ForwardRef as ReactComponent };